import { exploreRoutes } from './routes/general';
export const createExploreCategoryState = () => ({
    name: '',
    displayName: '',
    icon: '',
    sortOrder: 0,
    areaOnly: false,
});
export const findExploreCategory = (categories, name) => { var _a; return name === null ? null : (_a = categories.find(each => each.name === name)) !== null && _a !== void 0 ? _a : null; };
// Categories are records now, so an arrival slug cannot be checked against a fixed list. An unknown
// one resolves to no category and the server's kind subquery matches nothing.
export const parseExploreCategory = (value) => value === null || value.trim() === '' ? null : value;
const parseNumber = (value) => {
    const parsed = value === null || value.trim() === '' ? NaN : Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};
export const parseExploreCenter = (lat, lng) => {
    const latitude = parseNumber(lat);
    const longitude = parseNumber(lng);
    return latitude !== null && longitude !== null && Math.abs(latitude) <= 90 && Math.abs(longitude) <= 180
        ? [longitude, latitude]
        : null;
};
export const exploreURL = (target) => {
    const params = new URLSearchParams();
    if (target.query)
        params.set('q', target.query);
    if (target.category)
        params.set('category', target.category);
    if (target.center) {
        const [longitude, latitude] = target.center;
        params.set('lat', String(latitude));
        params.set('lng', String(longitude));
    }
    const search = params.toString();
    return `${exploreRoutes.explore.getURL()}${search ? `?${search}` : ''}`;
};
